/* Copyright (c) 2021 Nordcloud Oy or its affiliates. All Rights Reserved. */

import { displayCustomerCategory, isNotEmpty } from "~/tools";

function capitalize(input: string) {
  return input.charAt(0).toUpperCase() + input.slice(1);
}

export function getLabel(key: string, value: string | boolean | string[]) {
  if (Array.isArray(value) && isNotEmpty(value)) {
    switch (key) {
      case "provider":
        return `Provider: ${value.join(", ").replace("_", " ")}`;
      case "category":
        return `Category: ${value
          .map((c) => displayCustomerCategory(c))
          .join(", ")}`;
      default:
        return `${capitalize(key)}: ${value.length} selected`;
    }
  }

  return `${capitalize(key)}: ${value}`;
}
